import React, { useState, useContext, useEffect } from "react";
import { Row, Col, Button, Spinner, Card } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-hot-toast";
import PsContext from "../../../context/PsContext";
import API from "../../../utils/API";
import { momentDate } from "../../../utils";

const MyOrders = (props) => {
  const context = useContext(PsContext);
  const [loading, setLoading] = useState(true);
  const [repayLoader, setRepayLoader] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [reqData, setReqData] = useState(null);
  const [accessCode, setAccessCode] = useState(null);

  const loadOrderData = () => {
    setLoading(true);
    API.get(`v1/site/user/orders/${context.state.userData.id}`).then((res) => {
      if (res.data.status === "1") {
        setOrderData(res.data.data);
      }
      setLoading(false);
    });
  };

  const repayClick = () => {
    setRepayLoader(true);
    API.get(`v1/site/user/orders/${context.state.userData.id}`).then((res) => {
      if (res.data.status === "1") {
        setReqData(res.data.reqdata);
        setAccessCode(res.data.access_code);
        document.getElementById("frmCcPay").submit();
      } else {
        toast.error(res.data.message, {
          style: {
            marginTop: "5%",
            borderRadius: "4px",
            background: "#333",
            color: "#fff",
          },
        });
        setRepayLoader(false);
      }
    });
  };

  useEffect(() => {
    loadOrderData();
  }, []);

  // Filtered orders
  const completedOrders = orderData.filter(
    (item) => item.orderstatus !== "Payment pending"
  );
  const pendingOrders = orderData.filter(
    (item) => item.orderstatus === "Payment pending"
  );

  return (
    <>
      <div className="tf-page-title mb-50">
        <div className="container text-center">
          <div className="heading">My Orders</div>
          <p className="text-2 text_black-2 mt_5">
            Track and manage your orders
          </p>
        </div>
      </div>
      <div className="container mb-5">
        <Row className="justify-content-center">
          <Col md={12}>
            <Card className="shadow-sm border-0">
              <Card.Body>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="ps_round_loader mb-3"></div>
                    <div>Loading your orders...</div>
                  </div>
                ) : orderData.length > 0 ? (
                  <>
                    {/* Completed Orders */}
                    {completedOrders.length > 0 && (
                      <>
                        <h5 className="mb-3">Completed Orders</h5>
                        <div className="wrap-account-order mb-4">
                          <table
                            className="table table-hover"
                            style={{ fontSize: "14px" }}
                          >
                            <thead>
                              <tr>
                                <th className="fw-bold">#</th>
                                <th className="fw-bold">Date</th>
                                <th className="fw-bold">Order ID</th>
                                <th className="fw-bold text-end">Total</th>
                                <th className="fw-bold text-center">Status</th>
                                <th className="fw-bold text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {completedOrders.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {momentDate(item.orderdate, "DD/MM/YYYY")}
                                  </td>
                                  <td>{item.orderno}</td>
                                  <td className="text-end">
                                    ₹{parseFloat(item.totalprice).toFixed(2)}
                                  </td>
                                  <td className="text-center">
                                    <span className="badge bg-success">
                                      {item.orderstatus}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <Link
                                      to={`/user/order-status/${item.orderid}`}
                                      className="tf-btn btn-fill animate-hover-btn rounded-0 btn-sm"
                                    >
                                      <span>View</span>
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}

                    {/* Pending Orders */}
                    {pendingOrders.length > 0 && (
                      <>
                        <h5 className="mb-3">Pending Orders</h5>
                        <div className="wrap-account-order">
                          <table
                            className="table table-hover"
                            style={{ fontSize: "14px" }}
                          >
                            <thead>
                              <tr>
                                <th className="fw-bold">#</th>
                                <th className="fw-bold">Date</th>
                                <th className="fw-bold">Order ID</th>
                                <th className="fw-bold text-end">Total</th>
                                <th className="fw-bold text-center">Status</th>
                                <th className="fw-bold text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {pendingOrders.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {momentDate(item.orderdate, "DD/MM/YYYY")}
                                  </td>
                                  <td>{item.orderno}</td>
                                  <td className="text-end">
                                    ₹{parseFloat(item.totalprice).toFixed(2)}
                                  </td>
                                  <td className="text-center">
                                    <span className="badge bg-error">
                                      {item.orderstatus}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <Link
                                      to={`/user/order-status/${item.orderid}`}
                                      className="tf-btn btn-fill animate-hover-btn rounded-0 btn-sm"
                                    >
                                      <span>View</span>
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          {/* Repay Button */}
                          <div className="text-end mt-3">
                            <Button
                              variant="dark"
                              size="sm"
                              className="rounded-0"
                              disabled={repayLoader}
                              onClick={repayClick}
                            >
                              {repayLoader ? (
                                <>
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  &nbsp; Please wait...
                                </>
                              ) : (
                                "Repay Now"
                              )}
                            </Button>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <div className="text-center text-muted py-5">
                    <h5>No orders found.</h5>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Hidden CCAvenue Form */}
      <form
        action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction"
        method="post"
        name="redirect"
        id="frmCcPay"
      >
        <input type="hidden" name="encRequest" value={reqData || ""} />
        <input type="hidden" name="access_code" value={accessCode || ""} />
      </form>
    </>
  );
};

export default withRouter(MyOrders);
